// © Microsoft Corporation. All rights reserved.

import { AppType, PageType } from "@msnews/experiences-constants";
import { Market, appEnvironment } from "../app";

import { headData } from "../app/HeadData";

/**
 * Base class for page utility functions
 */
export namespace PageUtility {

    /**
     * Returns true if the current page is the DHP
     */
    export function isDhpPage(): boolean {
        return headData.ClientSettings.pagetype === PageType.DHP;
    }

    /**
     * Returns true if the current page is the NTP
     */
    export function isNtpPage(): boolean {
        return headData.ClientSettings.pagetype === PageType.NTP;
    }

    /**
     * Returns true if five column is supported or not
     */
    export function fiveColSupported(): boolean {
        if (!appEnvironment) {
            return false;
        }

        // restrict the flight to Anaheim apptype
        if (appEnvironment.AppType !== AppType.EdgeChromium) {
            return false;
        }

        // enable five column 100% for Anaheim for listed markets
        return appEnvironment.CurrentMarket === Market.ENUS
            || appEnvironment.CurrentMarket === Market.ENGB
            || appEnvironment.CurrentMarket === Market.DEDE
            || appEnvironment.CurrentMarket === Market.FRFR;
    }
}